import axios from "axios";
import { API } from "../config";

const path = "/dashboard";
const pathQuantidade = "/quantidade";
const pathGrafico = "/grafico";

class DashboardService {
  usuarioLogado(access_token) {
    return axios.get(API + `/usuario-logado`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getDadosDashboard(access_token) {
    return axios.get(API + path + `/dados`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getTotalServico(access_token) {
    return axios.get(API + path + pathQuantidade + `/servicos-acolhimento`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
  getTotalCrianca(access_token) {
    return axios.get(API + path + pathQuantidade + `/criancas-adolescentes`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
  getTotalCriancaPendencia(access_token) {
    return axios.get(API + path + pathQuantidade + `/pendencias-criancas`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getTotalServicoPendencia(access_token) {
    return axios.get(API + path + pathQuantidade + `/pendencias-servicos`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
  getTotalAvisos(access_token) {
    return axios.get(API + path + pathQuantidade + `/avisos`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getGraficoServico(access_token) {
    return axios.get(API + path + pathGrafico + `/servicos-acolhimento`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
  getGraficoCriancaTipo(access_token) {
    return axios.get(API + path + pathGrafico + `/criancas-adolescentes-por-tipo-servico`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }

  getGraficoCriancaTipoMensal(access_token) {
    return axios.get(API + path + pathGrafico + `/criancas-adolescentes-por-tipo-servico-mensal`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
  getGraficoAcolhidoGenero(access_token) {
    return axios.get(API + path + pathGrafico + `/acolhidos-por-genero`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
  getGraficoAcolhidoFaixa(access_token) {
    return axios.get(API + path + pathGrafico + `/acolhidos-por-faixa-etaria`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  }
}

const instanceDashboard = new DashboardService();
export default instanceDashboard;